import { Link, useNavigate } from '@tanstack/react-router';

import { EmailField, Form, SelectField, Submit, TextField } from '@src/corelib/forms/generic';
import { createSchema, Yup } from '@src/corelib/validation';
import { useMeQuery } from '@src/query';

import { useOnboarding } from './OnboardingContext';
import OnboardingShell from './OnboardingShell';


// LOGO is intentionally deferred to M9 Business settings (not collected here).

const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

// Prefer the full IANA list; fall back to a small curated set on older runtimes.
const TIMEZONES = (typeof Intl.supportedValuesOf === 'function'
  ? Intl.supportedValuesOf('timeZone')
  : [
    'UTC',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Phoenix',
    'America/Anchorage',
    'Pacific/Honolulu',
    'Europe/London',
    'Europe/Berlin',
  ]);

const schema = createSchema({
  name: Yup.string().required('Enter your business name'),
  contact_email: { type: 'email', label: 'Contact email', required: false },
  contact_phone: Yup.string(),
  timezone: Yup.string().required('Pick a timezone'),
});


function CreateOrg() {
  const navigate = useNavigate();
  const { draft, update } = useOnboarding();
  const { data: me } = useMeQuery();

  const onSubmit = (values) => {
    update(values);
    navigate({ to: '/onboarding/location' });
    return Promise.resolve();
  };

  return (
    <OnboardingShell
      step={1}
      title="Set up your yard"
      sub="Name your business — change it anytime in Settings."
      backTo="/onboarding"
    >
      <Form
        schema={schema}
        className="w-full text-left"
        defaultValues={{
          name: draft.name || me?.business_name || '',
          contact_email: draft.contact_email || me?.email || '',
          contact_phone: draft.contact_phone,
          timezone: draft.timezone || BROWSER_TZ,
        }}
        onSubmit={onSubmit}
      >
        <TextField name="name" label="Business name" placeholder="Smith Auto Salvage" />
        <EmailField name="contact_email" label="Contact email (optional)" placeholder="contact@yard.com" />
        <TextField name="contact_phone" label="Phone (optional)" placeholder="(555) 123-4567" />

        <SelectField name="timezone" label="Timezone">
          {TIMEZONES.map((tz) => <option key={tz} value={tz}>{tz}</option>)}
        </SelectField>

        <Submit fullWidth className="h-[46px] max-lg:h-[50px]">Create organization</Submit>
      </Form>

      <Link className="text-table font-medium text-primary" to="/onboarding">
        ← Back
      </Link>
    </OnboardingShell>
  );
}

CreateOrg.displayName = 'CreateOrg';
export default CreateOrg;
